// extracted by mini-css-extract-plugin
export var center = "_1m-2";
export var clickableRow = "_1m-5";
export var expandedRow = "_1m-7";
export var hoverable = "_1m-4";
export var left = "_1m-1";
export var right = "_1m-3";
export var row = "_1m-0";
export var selectedRow = "_1m-6";
export var summaryRow = "_1m-8";